import React, { useEffect, useMemo } from 'react';
import EmojiCard from './EmojiCard';
import VerticalBar from './VerticalBar';
import { Select } from 'antd';
import { useState } from 'react';
import images from '../../../themes/appImage';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { toolsMoodsLoggedLoad, toolsAverageMoodLoad } from '../../../redux/slices/tools.slice';



const { Option } = Select;




const NewChart = ({ tab }) => {
  let data = moment().month();
  const [month, setMonth] = useState(data)
  const currentDate = new Date();
  const firstDayOfMonth = new Date(Date.UTC(currentDate.getFullYear(), month, 1));
  const lastDayOfMonth = new Date(Date.UTC(currentDate.getFullYear(), month + 1, 0, 23, 59, 59));

  const averageData = {
    logType: "mood",
    startDate: firstDayOfMonth.toISOString(),
    endDate: lastDayOfMonth.toISOString()
  };

  const dispatch = useDispatch();

  useEffect(() => {
    if (tab == 1) {
      const data = {
        month: month,
      }
      dispatch(toolsMoodsLoggedLoad(data));
      dispatch(toolsAverageMoodLoad(averageData));
    }
  }, [month, tab, dispatch])

  const mydata = useSelector((state) => state.toolsReducer) || {};
  const moodsData = mydata?.toolsMoodsData;
  const averageMoodData = mydata?.toolsAverageData;
  const averageMoodName = averageMoodData?.averageMoodName;
  const percentageChange = averageMoodData?.percentageChange;

  const moodImageMap = {
    bestPossible: images.bestPossibleMood,
    "Best Possible": images.bestPossibleMood,
    great: images.greatMood,
    "Great": images.greatMood,
    veryGood: images.veryGoodMood,
    "Very Good": images.veryGoodMood,
    good: images.goodMood,
    "Good": images.goodMood,
    prettyGood: images.PrettyGood,
    "Pretty Good": images.PrettyGood,
    okay: images.okMood,
    "Okay": images.okMood,
    beenBetter: images.beenBetter,
    "Been Better": images.beenBetter,
    bad: images.badMood,
    "Bad": images.badMood,
    veryBad: images.veryBadMood,
    "Very Bad": images.veryBadMood,
    worstPossible: images.worstPossibleMood,
    "Worst Possible": images.worstPossibleMood,
  };
  const moodImage = averageMoodName ? moodImageMap[averageMoodName] || null : null;

  let totalSum = 0;
  for (const key in mydata.moodsData) {
    if (key != "_id") {
      totalSum += mydata?.moodsData[key];
    }
  }

  const moodData = useMemo(() => {
    return [
      { percentage: `${(totalSum !== 0 ? (mydata?.moodsData.bestPossible / totalSum) * 100 : 0)}`, imageSource: images.bestPossibleMood, altText: "bestPossible" },
      { percentage: `${(totalSum !== 0 ? (mydata?.moodsData.great / totalSum) * 100 : 0)}`, imageSource: images.greatMood, altText: "great" },
      { percentage: `${(totalSum !== 0 ? (mydata?.moodsData.veryGood / totalSum) * 100 : 0)}`, imageSource: images.veryGoodMood, altText: "veryGood" },
      { percentage: `${(totalSum !== 0 ? (mydata?.moodsData.good / totalSum) * 100 : 0)}`, imageSource: images.goodMood, altText: "good" },
      { percentage: `${(totalSum !== 0 ? (mydata?.moodsData.prettyGood / totalSum) * 100 : 0)}`, imageSource: images.PrettyGood, altText: "prettyGood" },
      { percentage: `${(totalSum !== 0 ? (mydata?.moodsData.okay / totalSum) * 100 : 0)}`, imageSource: images.okMood, altText: "okay" },
      { percentage: `${(totalSum !== 0 ? (mydata?.moodsData.beenBetter / totalSum) * 100 : 0)}`, imageSource: images.beenBetter, altText: "beenBetter" },
      { percentage: `${(totalSum !== 0 ? (mydata?.moodsData.bad / totalSum) * 100 : 0)}`, imageSource: images.badMood, altText: "bad" },
      { percentage: `${(totalSum !== 0 ? (mydata?.moodsData.veryBad / totalSum) * 100 : 0)}`, imageSource: images.veryBadMood, altText: "veryBad" },
      { percentage: `${(totalSum !== 0 ? (mydata?.moodsData.worstPossible / totalSum) * 100 : 0)}`, imageSource: images.worstPossibleMood, altText: "worstPossible" }
    ]
  }, [mydata?.moodsData])
    ;

  const handleMonthChange = value => {
    console.log("the value of month is", value);
    setMonth(value);
  };

  return (
    <div>


      <div className='flex justify-between  lg:flex-col lg:items-center  gap-3 w-[100%]'>
        <div className='w-[70%] pb-2'>
          <div className='flex  items-center justify-between months-selector  '>
            <div></div>
            <div className='w-[100px]'>
            <Select defaultValue={month.toString()} onChange={handleMonthChange}>
              <Option value="0">January</Option>
              <Option value="1">February</Option>
              <Option value="2">March</Option>
              <Option value="3">April</Option>
              <Option value="4">May</Option>
              <Option value="5">June</Option>
              <Option value="6">July</Option>
              <Option value="7">August</Option>
              <Option value="8">September</Option>
              <Option value="9">October</Option>
              <Option value="10">November</Option>
              <Option value="11">December</Option>
            </Select>
            </div>
          </div>

          <div className='flex gap-5 h-[300px] items-end px-[15px] justify-evenly'>
            {moodData.map((mood, index) => (
              <VerticalBar
                key={index}
                barPercentage={Number(mood.percentage) > 100 ? "100%" : Number(mood.percentage) < 18 ? "18%" : (mood.percentage) + "%"}
                textPercentage={Math.floor(Number(mood.percentage)) + "%"}
                imageSource={mood.imageSource}
                altText={mood.altText}
              />
            ))}
          </div>
        </div>
        <div className='w-[30%] flex mb-2'>
          <EmojiCard
            moodImage={moodImage}
            moodDescription={averageMoodName}
            percentageChange={percentageChange}
          />
        </div>
      </div>
    </div>
  );
};

export default NewChart;
